import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import common from 'common-web';
import ReceiptSearchHelper from '../ReceiptSearchHelper';
import BrownPin from '../../images/ic_pin_brown.png';
import RedPin from '../../images/ic_pin_red.png';

const SearchBar = common.components.searchBar();
const SearchContainer = common.components.locationsContainer();
const MapComponent = common.components.map();
const Card = common.components.card();

/* eslint-disable no-confusing-arrow */
const RestaurantInformationStyled = styled.div`
    background: white;
`;

const SubtitleHeader = styled.div`
  font-size: 25px;
  margin: 16px 0;
  text-transform: capitalize;
  color: #3E2723;
  letter-spacing: 0;
  font-family: IntroRegular;
`;

const RestaurantLocationStyled = styled.div`
  font-family: OpenSans;
  font-size: 12px;
  color: #3E2723;
  letter-spacing: 0;
  line-height: 20px;
  padding-bottom: 21px;
`;

const ErrorSpanStyled = styled.span`
    transition: all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1);
    top: -12px;
    display: ${props => props.display};
    text-transform: uppercase;
    color: #CD2028;
    font-weight: bold;
    font-size: 10.5px;

    & span {
        text-transform: capitalize;
        font-weight: normal;
    }
`;
/* eslint-enable no-confusing-arrow */

class RestaurantInformation extends Component {
    constructor() {
        super();
        this.state = {
            selectedLocation: null,
            showInfo: false,
            activeMarker: {},
            zoom: 4
        };
    }

    render() {
        const defaultSearchForRestaurant = 'Search for a restaurant location using city,state, or zipcode or search for the restaurant number from your receipt.';
        const defaultFindRestaurantNumberOnReceipt = 'How to find the restaurant number on your receipt';

        return (
            <RestaurantInformationStyled>
                <ErrorSpanStyled display={this.props.errors.locationId ? 'inline' : 'none'}>
                    {this.props.getLocalizedText('RestaurantInformation', 'restaurant information')} <span>{this.props.getLocalizedText('Required', 'required')}</span>
                </ErrorSpanStyled>
                <SubtitleHeader>
                    {this.props.getLocalizedText('RestaurantInformation', 'restaurant information')}
                </SubtitleHeader>
                <RestaurantLocationStyled>
                    {this.props.getLocalizedText('SearchForRestaurant', defaultSearchForRestaurant)}
                </RestaurantLocationStyled>
                {this.getSearchBar()}
                <ReceiptSearchHelper
                    linkText={this.props.getLocalizedText('FindRestaurantNumberOnReceipt', defaultFindRestaurantNumberOnReceipt)}
                    width={'340px'}
                    getLocalizedText={this.props.getLocalizedText}
                    locale={this.props.locale} />
                <SearchContainer
                    map={this.getMap()}
                    locations={this.makeResults()}
                    getLocalizedText={this.props.getLocalizedText}
                    locale={this.props.locale} />
            </RestaurantInformationStyled>
        );
    }

    componentWillReceiveProps(nextProps) {
        const locations = nextProps.locations;
        const selectedLocation = this.state.selectedLocation;

        if (!locations) {
            this.setState({ showInfo: false });
            return;
        }

        if (locations.length) { this.setState({ zoom: 10 }); }

        if (this.state.showInfo && selectedLocation) {
            const hasSelectedLocation = locations.find(location =>
                location.id === selectedLocation.id
            );
            if (!hasSelectedLocation) this.setState({ showInfo: false });
        }
    }

    getSearchBar = () => (<SearchBar
            refName="map"
            locationSuggestions={this.props.locationSuggestions}
            onSearch={this.props.onSearch}
            clearLocationSuggestions={this.props.clearLocationSuggestions}
            getLocalizedText={this.props.getLocalizedText}
            locale={this.props.locale} />
    );

    onSearch = (searchParam) => {
        this.props.onSearch(searchParam);
    };

    getPinUrl = (location, selectedLocation) => {
        if (selectedLocation && location.id === selectedLocation.id) {
            return RedPin;
        }
        return BrownPin;
    };

    makeResults = () => {
        if (!this.props.locations) {
            return undefined;
        }

        return this.props.locations.map((location, index) => (
                <Card key={index}
                      location={location}
                      index={index}
                      hasSelectionBorder={this.state.selectedLocation &&
                      (location.id === this.state.selectedLocation.id)}
                      pinUrl={this.getPinUrl(location, this.state.selectedLocation)}
                      selectHandler={ () => (this.cardHandler(location)) } />
            ));
    };

    getMap = () => {
        if (!this.props.locations) {
            return undefined;
        }
        const window = global.window || null; // eslint-disable-line no-use-before-define
        return (<MapComponent
            locations={this.props.locations}
            selectedLocation={this.state.selectedLocation}
            setParentState={(...args) => this.setState(...args)}
            showInfo= {this.state.showInfo}
            activeMarker={this.state.activeMarker}
            google={window.google}
            getPinUrl={this.getPinUrl}
            zoom={this.state.zoom}
            />
        );
    };

    cardHandler = (location) => {
        this.props.onLocationSelection(location);
        this.setState({
            activeMarker: {},
            selectedLocation: location,
            showInfo: true
        });
    }
}

RestaurantInformation.propTypes = {
    errors: PropTypes.object,
    locations: PropTypes.array,
    locationSuggestions: PropTypes.array,
    onLocationSelection: PropTypes.func.isRequired,
    onSearch: PropTypes.func,
    clearLocationSuggestions: PropTypes.func,
    getLocalizedText: PropTypes.func.isRequired,
    locale: PropTypes.shape({
        country: PropTypes.string,
        language: PropTypes.string,
        localeCode: PropTypes.string
    })
};

RestaurantInformation.defaultProps = {
    errors: {},
    locations: [],
    locationSuggestions: [],
    onSearch: () => {},
    clearLocationSuggestions: () => {},
    onLocationSelection: () => {},
    getLocalizedText: (key, defaultValue) => defaultValue,
    locale: {
        country: 'US',
        language: 'en',
        localeCode: 'en_US'
    }
};

export default RestaurantInformation;



// WEBPACK FOOTER //
// ./src/components/RestaurantInformation/index.js